import { ProductIdentifier } from 'components/common/types/DirectSalesProductTemplate.types';

export const defaultAllFoldersProductOption = {
  code: 'All folders',
  name: 'All folders',
};

export const getProductsByFolderName = ({
  folderName,
  products,
}: {
  folderName: string;
  products: ProductIdentifier[];
}): ProductIdentifier[] => {
  const normalizedFolderName = folderName.toLowerCase();

  if (normalizedFolderName === defaultAllFoldersProductOption.code.toLowerCase()) {
    return products;
  }

  return products.filter(({ folder }) => folder.toLowerCase() === normalizedFolderName);
};
